var map = {
	"./en.js": 1382,
	"./es.js": 1383,
	"./index.js": 717
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1381;


//////////////////
// WEBPACK FOOTER
// ./src/helper/ln nonrecursive \.js$
// module id = 1381
// module chunks = 38